import { useEffect, useState } from 'react';
import { AppConfig, isValidAppConfig } from 'types';
import { AppRoutes } from 'AppRoutes';
import { buildAPI, DEFAULT_APP_CONFIG } from 'consts';
import { HandleResponse } from 'services/http';

export default function App() {
	const [config, setConfig] = useState('localhost' === window.location.hostname ? DEFAULT_APP_CONFIG : null);

	useEffect(() => {
		if (!config) {
			fetch('/environment')
				.then(HandleResponse)
				.then((cfg: AppConfig) => {
					if (isValidAppConfig(cfg)) {
						setConfig({
							...DEFAULT_APP_CONFIG,
							...cfg,
							API: buildAPI(cfg.API_URL)
						});
					} else {
						console.error('INVALID CONFIG:', cfg);
					}
				});
		}
	}, [config]);

	return config ? <AppRoutes config={config} /> : null;
}
